import Column from '@components/Column';
import Indicator from '@components/Indicator';
import Row from '@components/Row';
import useScrollIndicator from '@hooks/ui/useScrollIndicator';

import AllButton from './AllButton';
import MyMenu from './MyMenu';
import PickButton from './PickButton';
import styles from './styles.module.scss';
import useScrollEnd from './useScrollEnd';

function MyMenus() {
    const { isScrolling, onScroll: onScrollWithEnd } = useScrollEnd({ id: 'my-menus' });
    const { onScroll, current } = useScrollIndicator({ totalCount: 10, padding: 30 });
    return (
        <Column align='center'>
            <Row spacing={16}
                className={styles.container}
                id='my-menus'
                onScroll={(e) => {
                    onScrollWithEnd();
                    onScroll(e);
                }}
                fullWidth >
                <PickButton isScrolling={isScrolling}/>
                {Array.from({ length: 10 }, (_, i) => (
                    <MyMenu key={`myMenu${i}`}/>
                ))}
                <AllButton/>
            </Row>
            <Indicator total={10} current={current} />
        </Column>);
}

export default MyMenus;
